export const resetModal = {
  extends: 'ModalWindow',
  tag: 'form',
  state: null,
  ModalHeader: {
    title: 'Reset',
    p: 'Do you want to revert to the latest release?'
  },
  cnt: {
    props: {
      padding: '- B1 - -'
    },
    P: {
      props: {
        color: 'paragraph'
      },
      text: (el) =>
        el
          .call('polyglot', 'editor.resetModal.reverting')
          .replace('{version}', el.getRootState().version)
    }
  },
  ModalFooter: {
    CheckButton: {
      type: 'submit',
      text: '{{ common.action.reset | polyglot }}'
    }
  },
  on: {
    submit: async (e, el, s, ctx) => {
      e.preventDefault()
      await el.call('closeRouterModal')
    }
  }
}
